<template>
  <section class="post-section">
    <h3 class="post-section__title">Dados do destinatário</h3>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="post-form">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('nome')" prop="name" class="is-required">
            <el-input maxlength="50" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('cpf/cnpj')" prop="active">
            <el-input v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']" v-model="ruleForm.federalid"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="6">
          <el-form-item :label="$t('cep')" prop="cep">
            <el-input
              maxlength="9"
              v-model="ruleForm.zipcode"
              v-mask="'#####-###'"
              v-loading="loading"
              @blur="zipcode()"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
          <el-form-item :label="$t('endereco')" prop="address" :required="true">
            <el-input maxlength="50" v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="10">
          <el-form-item :label="$t('bairro')" prop="neighborhood" :required="true">
            <el-input v-model="ruleForm.neighborhood" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8">
          <el-form-item :label="$t('cidade')" prop="city" :required="true">
            <el-input v-model="ruleForm.city" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="4" :md="6">
          <el-form-item :label="$t('estado')" prop="state" :required="true">
            <el-input v-model="ruleForm.state" maxlength="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="6">
          <el-form-item :label="$t('numero')" prop="name" class="is-required">
            <el-input maxlength="6" v-model="ruleForm.number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('complemento')" prop="active">
            <el-input maxlength="40" v-model="ruleForm.complement"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-form-item :label="$t('pedido')" prop="name">
            <el-input maxlength="100" v-model="ruleForm.request"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </section>
</template>
<script>
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "PostDelivered",
  props: ["form", "data"],
  mounted() {
    this.ruleForm.zipcode = this.form.destinyZipcode;
  },
  data() {
    return {
      userType: "2",
      loading: false,
      ruleForm: {
        name: "",
        federalid: "",
        zipcode: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        complement: "",
        request: "",
        invoice: "",
      },
    };
  },
  methods: {
    setup(form, data) {
      this.ruleForm.zipcode = form.destinyZipcode;
      if (this.ruleForm.zipcode) {
        this.zipcode();
      }
    },
    zipcode() {
      const vm = this;
      this.loading = true;
      PostOfficeService.zipcode(vm.ruleForm.zipcode)
        .then((response) => {
          vm.ruleForm.address = response.end;
          vm.ruleForm.city = response.cidade;
          vm.ruleForm.state = response.uf;
          vm.ruleForm.neighborhood = response.bairro;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
